import { JournalToolsProviderService } from '@addins/core/journal';
import { FreetextToolService } from '@addins/singlecallcard-journal';
import { Injectable } from '@angular/core';
import { AddFreeTextTool } from '../../schema/add-free-text-tool';

@Injectable({
  providedIn: 'root'
})
export class JournalToolsControllerService {
  private addFreeTextTool: AddFreeTextTool;

  constructor(private journalTools: JournalToolsProviderService, private freeTextTool: FreetextToolService) {}

  setup() {
    this.addFreeTextTool = new AddFreeTextTool(task => this.freeTextTool.addFreeText(task.ObjGuid));
    this.journalTools.add(this.addFreeTextTool);
  }
}
